<script setup lang="ts">
import {useApiClient} from "@/api/client";
import {toastApiResult} from "@/toaster";
import GeneralUserSettings from "@/modules/users/components/GeneralUserSettings.vue";
import {useBaseStore} from "@/stores/base";
import {passwordFieldsType} from "@/api/resources/users";
import {shallowRef} from "vue";
import PhoneVerificationDialog from "@/modules/profile/components/PhoneVerificationDialog.vue";
import {cloneFnJSON} from "@vueuse/core";

const store = useBaseStore();
const client = useApiClient("users");
const showVerificationDialog = shallowRef(false);
const originalPhoneNumber = shallowRef(store.currentUser.phone_number);

const updateUser = async (user: App.Data.UserDO) => {
	if (user.phone_number.length > 0 && user.phone_number !== originalPhoneNumber.value) {
		showVerificationDialog.value = true;
		originalPhoneNumber.value = store.currentUser.phone_number;
	} else {
		const response = await toastApiResult(client.updateProfile(user));
		if (response.isOk()) {
			store.currentUser = response.value;
		}
	}
};

const updatePassword = async (passwordFields: passwordFieldsType) => {
	return await toastApiResult(client.updateProfilePassword(passwordFields));
};
</script>

<template>
	<PhoneVerificationDialog v-model:visible="showVerificationDialog"/>
	<general-user-settings
		:user="store.currentUser"
		:async-update-function="updateUser"
		:async-update-password-function="updatePassword"
		:is-profile-page="true"
	/>
</template>

<style lang="scss">
.v-expansion-panel-title__overlay {
	background: rgba(var(--v-theme-primary)) !important;
}
</style>
